import { ts } from '_core';

import { getName, validate } from './helpers';
import { DraftParams } from './types';

export default [
  {
    key: ts.enums.REPORT_ENUMS.WIDGET_KEY_ENUM.RISK_MODEL_SPECIFIC_RISK_DISTRIBUTION,
    title: 'Specific Risk Distribution vs. Time',
    helpLabel: 'oxw0bhf7e9',
    form: true,
    defaultParams: {
      window: 21,
    } as DraftParams,
    neededFiles: ['risk_model_specific_risk_distribution'],
    tags: [
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.RISK_MODEL,
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.COMMON_RISK_MODEL,
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.STATISTICAL_RISK_MODEL,
    ],
    validate,
    getName,
  },
] satisfies ts.types.analysis.WidgetConfig[];
